<template>
  <div>
    <h5 class="text-center upper-text color-sysblue back-ground-grey p-2">
      MEDICAMENTOS QUE O RESIDENTE PEGOU EMPRESTADO
    </h5>
    <div class="text-right filters pr-4">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          :id="`show_text_devolution_was_borrowed_${resident_id}`"
          v-model="show_text_devolution_was_borrowed"
        />
        <label
          class="form-check-label"
          :for="`show_text_devolution_was_borrowed_${resident_id}`"
        >
          MOSTRAR SE FOI FEITO A DEVOLUÇÃO
        </label>
      </div>
    </div>
    <div class="text-center p-5" v-if="items.length == 0">0</div>
    <div class="was-borrowed" v-for="(medicine, key) in items" :key="key">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h5 class="mb-0 check-text-center">
          {{ medicine.medicine_name }}
        </h5>
        <h6 class="legends worksansr mb-0 check-text-center">
          {{ medicine.medicine_active_ingredient }}
        </h6>
        <div class="d-flex residenttop-content check-text-center">
          <h6
            class="btn-pendent"
            v-if="medicine.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'"
          >
            CONTROLE ESPECIAL
          </h6>
        </div>
        <h6
          class="
            warning-alert
            text-thirteen
            inline-display
            mb-0
            check-text-center
          "
          v-if="medicine.group_prescription_medicine_type == 'LONGO_PRAZO'"
        >
          MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO!
        </h6>
        <h6
          v-if="medicine.frequency == 'EVENTUAL'"
          class="legends mb-0 c-secondary check-text-center"
        >
          MEDICAMENTO EVENTUAL
        </h6>
        <div v-if="medicine.medicine_amount_of_times_name">
          <p class="legends worksansr mb-0 check-text-center">
            {{ medicine.medicine_amount_of_times_name }}
          </p>
        </div>
        <div v-if="medicine.medicine_amount_of_times_type == 'SHIFTS'">
          <!-- Madrugada -->
          <div v-if="medicine.dawn && medicine.dawn_quantity">
            {{
              medicine.drops_dawn_quantity
                ? `${medicine.drops_dawn_quantity} GOTA(S)`
                : medicine.ui_dawn_quantity
                ? `${medicine.ui_dawn_quantity} UI`
                : medicine.dawn_quantity
            }}
            {{
              medicine.drops_dawn_quantity
                ? ""
                : medicine.ui_dawn_quantity
                ? ""
                : `${medicine.unit_of_measurement_abbreviation} (S)`
            }}
            / MANHÃ /
          </div>
          <!-- Manhã -->
          <div v-if="medicine.morning && medicine.morning_quantity">
            {{
              medicine.drops_morning_quantity
                ? `${medicine.drops_morning_quantity} GOTA(S)`
                : medicine.ui_morning_quantity
                ? `${medicine.ui_morning_quantity} UI`
                : medicine.morning_quantity
            }}
            {{
              medicine.drops_morning_quantity
                ? ""
                : medicine.ui_morning_quantity
                ? ""
                : `${medicine.unit_of_measurement_abbreviation} (S)`
            }}
            / MANHÃ /
          </div>
          <!-- Tarde -->
          <div v-if="medicine.afternoon && medicine.afternoon_quantity">
            {{
              medicine.drops_afternoon_quantity
                ? `${medicine.drops_afternoon_quantity} GOTA(S)`
                : medicine.ui_afternoon_quantity
                ? `${medicine.ui_afternoon_quantity} UI`
                : medicine.afternoon_quantity
            }}
            {{
              medicine.drops_afternoon_quantity
                ? ""
                : medicine.ui_afternoon_quantity
                ? ""
                : `${medicine.unit_of_measurement_abbreviation} (S)`
            }}
            / TARDE /
          </div>
          <!-- Noite -->
          <div v-if="medicine.night && medicine.night_quantity">
            {{
              medicine.drops_night_quantity
                ? `${medicine.drops_night_quantity} GOTA(S)`
                : medicine.ui_night_quantity
                ? `${medicine.ui_night_quantity} UI`
                : medicine.night_quantity
            }}
            {{
              medicine.drops_night_quantity
                ? ""
                : medicine.ui_night_quantity
                ? ""
                : `${medicine.unit_of_measurement_abbreviation} (S)`
            }}
            / NOITE /
          </div>
          <!-- 5º -->
          <div v-if="medicine.shift_5 && medicine.shift_5_quantity">
            {{
              medicine.drops_shift_5_quantity
                ? `${medicine.drops_shift_5_quantity} GOTA(S)`
                : medicine.ui_shift_5_quantity
                ? `${medicine.ui_shift_5_quantity} UI`
                : medicine.shift_5_quantity
            }}
            {{
              medicine.drops_shift_5_quantity
                ? ""
                : medicine.ui_shift_5_quantity
                ? ""
                : `${medicine.unit_of_measurement_abbreviation} (S)`
            }}
            / 5º /
          </div>
          <!-- 6º -->
          <div v-if="medicine.shift_6 && medicine.shift_6_quantity">
            {{
              medicine.drops_shift_6_quantity
                ? `${medicine.drops_shift_6_quantity} GOTA(S)`
                : medicine.ui_shift_6_quantity
                ? `${medicine.ui_shift_6_quantity} UI`
                : medicine.shift_6_quantity
            }}
            {{
              medicine.drops_shift_6_quantity
                ? ""
                : medicine.ui_shift_6_quantity
                ? ""
                : `${medicine.unit_of_measurement_abbreviation} (S)`
            }}
            / 6º /
          </div>
          <!-- 7º -->
          <div v-if="medicine.shift_7 && medicine.shift_7_quantity">
            {{
              medicine.drops_shift_7_quantity
                ? `${medicine.drops_shift_7_quantity} GOTA(S)`
                : medicine.ui_shift_7_quantity
                ? `${medicine.ui_shift_7_quantity} UI`
                : medicine.shift_7_quantity
            }}
            {{
              medicine.drops_shift_7_quantity
                ? ""
                : medicine.ui_shift_7_quantity
                ? ""
                : `${medicine.unit_of_measurement_abbreviation} (S)`
            }}
            / 7º /
          </div>
          <!-- 8º -->
          <div v-if="medicine.shift_8 && medicine.shift_8_quantity">
            {{
              medicine.drops_shift_8_quantity
                ? `${medicine.drops_shift_8_quantity} GOTA(S)`
                : medicine.ui_shift_8_quantity
                ? `${medicine.ui_shift_8_quantity} UI`
                : medicine.shift_8_quantity
            }}
            {{
              medicine.drops_shift_8_quantity
                ? ""
                : medicine.ui_shift_8_quantity
                ? ""
                : `${medicine.unit_of_measurement_abbreviation} (S)`
            }}
            / 8º /
          </div>
        </div>
        <div
          v-if="
            medicine.medicine_amount_of_times_type == 'DAY' ||
            medicine.frequency == 'EVENTUAL'
          "
        >
          <p class="legends worksansr mb-0 check-text-center">
            {{
              medicine.drops_quantity
                ? `${medicine.drops_quantity} GOTA(S)`
                : medicine.ui_quantity
                ? `${medicine.ui_quantity} UI`
                : medicine.quantity
            }}
            {{
              medicine.drops_quantity
                ? ""
                : medicine.ui_quantity
                ? ""
                : `${medicine.unit_of_measurement_name} (S)`
            }}
          </p>
        </div>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
        <div
          class="row"
          v-for="(stock, index) in medicine.stocks"
          v-show="stock.checks.length > 0"
          :key="index"
        >
          <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12">
            <h6 class="m-0 upper-text worksansr check-text-center">
              Emprestado de <strong>{{ stock.stock_owner }}</strong>
            </h6>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
            <h6 class="m-0 upper-text worksansr check-text-center">
              Total emprestado
              <strong>
                {{
                  medicine.drops_quantity
                    ? `${stock.total_was_borrowed} GOTA(S)`
                    : medicine.ui_quantity
                    ? `${stock.total_was_borrowed} UI`
                    : stock.total_was_borrowed
                }}
                {{
                  medicine.drops_quantity
                    ? ""
                    : medicine.ui_quantity
                    ? ""
                    : `${medicine.unit_of_measurement_name} (S)`
                }}

                <span
                  class="upper-text check-text-center"
                  v-if="medicine.drops_quantity || medicine.ui_quantity"
                >
                  / OU
                  {{ stock.total_quantity }}
                  {{ `${medicine.unit_of_measurement_name} (S)` }}
                </span>
              </strong>
            </h6>
          </div>
          <div
            class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 check-text-right"
          >
            <v-btn
              v-if="stock.resident_id && stock.action_devolution"
              @click="
                handleToDevolution(
                  stock.resident_id,
                  stock.medicine_id,
                  stock.medicine_type
                )
              "
              class="v-default"
              >FAZER DEVOLUÇÃO</v-btn
            >
            <h6
              class="color-orange"
              v-if="stock.resident_id && !stock.action_devolution"
            >
              DEVOLUÇÃO JÁ REALIZADA
            </h6>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h6 class="upper-text text-center check-text-center">Emprestado</h6>
            <div v-for="(check, k) in stock.checks" :key="k">
              <div class="row">
                <div
                  class="
                    col-md-6 col-lg-6 col-md-6 col-sm-6 col-12
                    d-flex
                    align-items-center
                    justify-content-center
                    pt-0
                    pb-0
                  "
                >
                  <h6
                    v-if="medicine.medicine_amount_of_times_type == 'DAY'"
                    class="mb-1 mr-1 check-text-center worksansr"
                  >
                    {{
                      medicine.drops_quantity
                        ? `${medicine.drops_quantity} GOTA(S)`
                        : medicine.ui_quantity
                        ? `${medicine.ui_quantity} UI`
                        : medicine.quantity
                    }}
                    {{
                      medicine.drops_quantity
                        ? ""
                        : medicine.ui_quantity
                        ? ""
                        : `${medicine.unit_of_measurement_name} (S)`
                    }}
                  </h6>
                  <div
                    v-if="medicine.medicine_amount_of_times_type == 'SHIFTS'"
                  >
                    <h6
                      class="mb-1 mr-1 check-text-center worksansr"
                      v-if="medicine.morning && medicine.morning_quantity"
                    >
                      {{
                        check.drops
                          ? `${check.drops} GOTA(S)`
                          : check.ui
                          ? `${check.ui} UI`
                          : check.quantity
                      }}
                      {{
                        check.drops
                          ? ""
                          : check.ui
                          ? ""
                          : `${check.unit_of_measurement_abbreviation} (S)`
                      }}
                    </h6>
                  </div>
                  <h6 class="mb-1 check-text-center worksansr">
                    no dia {{ formatDate(check.created_at) }} por
                    {{ check.user_name }}
                  </h6>
                </div>
                <div
                  v-if="show_text_devolution_was_borrowed"
                  class="col-md-6 col-lg-6 col-md-6 col-sm-6 col-12 text-center"
                >
                  <h6
                    v-if="check.devolution_has_medicine.length == 0"
                    class="upper-text color-deleted check-text-center m-0"
                  >
                    Não devolveu!
                  </h6>
                  <h6
                    class="upper-text color-sysblue check-text-center m-0"
                    v-for="devolution_has_medicine in check.devolution_has_medicine"
                    :key="devolution_has_medicine.id"
                  >
                    Devolução
                    {{ devolution_has_medicine.quantity }}
                    {{ `${medicine.unit_of_measurement_name} (S)` }}
                    no dia {{ formatDate(devolution_has_medicine.created_at) }}
                  </h6>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../../../lib/format";

export default {
  name: "Borrowed",
  data() {
    return {
      show_text_devolution_was_borrowed: false,
    };
  },
  props: {
    items: Array,
    resident_id: [Number, String],
  },
  methods: {
    formatDate,
    handleToDevolution(resident_id, medicine_id, medicine_type) {
      let route = this.$router.resolve({
        name: "resident",
        params: {
          id: resident_id,
        },
        query: {
          tab: "stock",
          nav: "devolution",
          medicine_id,
          type: medicine_type,
          resident_id: this.resident_id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
